// Ingreso / Egreso — código de validación de un comprobante de caja, con la
// aritmética GCODEGIG del Clipper (ver gcodegig.js). Una sola operación para
// los dos tipos: el permiso es el mismo.
//
// La fecha es la del día, inyectada: el código vence a la medianoche.

import { gcodegig } from "./gcodegig.js";

const TIPOS = { EG: "Egreso", IG: "Ingreso" };

/**
 * Importe tal como lo tipea el operador: sin separador de miles, con coma o
 * punto como decimal y hasta 2 decimales. Devuelve NaN si no respeta eso.
 */
export function leerImporte(texto) {
  const limpio = String(texto ?? "").trim().replace(",", ".");
  return /^\d+(\.\d{1,2})?$/.test(limpio) ? Number(limpio) : NaN;
}

export function validar({ tipo, nroComprobante, importe, sucursal }) {
  if (!TIPOS[tipo]) {
    return "Elegí si es un ingreso o un egreso";
  }
  const nro = String(nroComprobante ?? "").trim();
  if (!/^\d{1,5}$/.test(nro) || parseInt(nro, 10) < 1) {
    return "Número incorrecto. Se esperan hasta 5 dígitos";
  }
  const imp = leerImporte(importe);
  if (isNaN(imp) || imp === 0) {
    return "Importe incorrecto. Usá centavos con coma, sin puntos de miles (ej. 1234,56)";
  }
  if (!sucursal) {
    return "Elegí la sucursal";
  }
  return null;
}

export function calcular({ tipo, nroComprobante, importe, sucursal }, hoy = new Date()) {
  const nro = parseInt(nroComprobante, 10);
  const imp = leerImporte(importe);
  const codigo = gcodegig(Number(sucursal), hoy, tipo, nro, imp);
  if (codigo === -1) throw new Error("Parámetros incorrectos para el código");

  return {
    codigo: String(codigo).padStart(4, "0"),
    detalle: {
      tipo: TIPOS[tipo],
      nroComprobante: nro,
      importe: imp.toFixed(2),
      sucursalId: sucursal,
    },
  };
}
